"use client"
/* */
import { hash } from 'object-code';
import { avatarColors } from '../../Avatar/avatarColors.mjs';

const getColorFromInitials = (initials) => {
  const code = hash(initials);
  const number = Math.abs(code % (avatarColors.length - 1));
  return avatarColors[number] ?? "blue";
};

export { getColorFromInitials };
//# sourceMappingURL=getColorFromInitials.mjs.map
